/* Skarpast – offertkorg (quote cart). Lagras i localStorage, separat från Shopify-kassan. */
(function () {
  var KEY = 'sk_quote_cart';

  function read() {
    try {
      return JSON.parse(window.localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* ignorera */
    }
    updateCount();
  }
  function updateCount() {
    var count = read().reduce(function (sum, item) { return sum + item.quantity; }, 0);
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-quote-count]'), function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function variantTitle(button) {
    var script = button.parentElement
      ? button.parentElement.querySelector('script[data-sk-quote-variants]')
      : null;
    if (!script) return { id: null, title: '', sku: '' };
    try {
      var variants = JSON.parse(script.textContent);
      var select = document.querySelector('form[action*="/cart/add"] select[name="id"], product-form-component select[name="id"]');
      var selectedId = select ? parseInt(select.value, 10) : null;
      var found = variants.filter(function (v) { return v.id === selectedId; })[0] || variants[0];
      return found || { id: null, title: '', sku: '' };
    } catch (e) {
      return { id: null, title: '', sku: '' };
    }
  }

  function drawer() {
    return document.querySelector('[data-sk-quote-drawer]');
  }
  function openDrawer() {
    var el = drawer();
    if (!el) return false;
    renderList();
    el.hidden = false;
    document.body.classList.add('sk-quote-open');
    return true;
  }
  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.hidden = true;
    document.body.classList.remove('sk-quote-open');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var openBtn = target.closest('[data-sk-quote-open]');
    if (openBtn) {
      if (openDrawer()) event.preventDefault();
      return;
    }

    if (target.closest('[data-sk-quote-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var addBtn = target.closest('[data-sk-quote-add]');
    if (addBtn) {
      event.preventDefault();
      var variant = variantTitle(addBtn);
      var items = read();
      var existing = items.filter(function (item) {
        return item.handle === addBtn.dataset.productHandle && item.variantId === variant.id;
      })[0];
      if (existing) {
        existing.quantity += 1;
      } else {
        items.push({
          handle: addBtn.dataset.productHandle,
          title: addBtn.dataset.productTitle,
          url: addBtn.dataset.productUrl,
          image: addBtn.dataset.productImage,
          variantId: variant.id,
          variantTitle: variant.title,
          sku: variant.sku,
          quantity: 1
        });
      }
      write(items);
      renderList();
      openDrawer();
      return;
    }

    var qtyBtn = target.closest('[data-sk-quote-qty]');
    if (qtyBtn) {
      var items2 = read();
      var idx = parseInt(qtyBtn.dataset.skQuoteQty, 10);
      var delta = parseInt(qtyBtn.dataset.delta, 10);
      if (items2[idx]) {
        items2[idx].quantity = Math.max(1, items2[idx].quantity + delta);
        write(items2);
        renderList();
      }
      return;
    }

    var removeBtn = target.closest('[data-sk-quote-remove]');
    if (removeBtn) {
      var items3 = read();
      items3.splice(parseInt(removeBtn.dataset.skQuoteRemove, 10), 1);
      write(items3);
      renderList();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderList() {
    var lists = document.querySelectorAll('[data-sk-quote-items]');
    if (!lists.length) return;
    var items = read();
    var isEmpty = items.length === 0;

    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-quote-layout]'), function (el) {
      el.hidden = isEmpty;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-quote-empty]'), function (el) {
      el.hidden = !isEmpty;
    });
    if (isEmpty) {
      Array.prototype.forEach.call(lists, function (list) { list.innerHTML = ''; });
      return;
    }

    var html = items.map(function (item, i) {
      return (
        '<li class="sk-quote-cart__item">' +
        (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '') +
        '<div class="sk-quote-cart__item-info">' +
        '<p class="sk-quote-cart__item-title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></p>' +
        (item.variantTitle && item.variantTitle !== 'Default Title'
          ? '<p class="sk-quote-cart__item-variant">' + escapeHtml(item.variantTitle) + (item.sku ? ' · art. ' + escapeHtml(item.sku) : '') + '</p>'
          : '') +
        '<button type="button" class="sk-quote-cart__remove" data-sk-quote-remove="' + i + '">Ta bort</button>' +
        '</div>' +
        '<div class="sk-quote-cart__item-qty">' +
        '<button type="button" data-sk-quote-qty="' + i + '" data-delta="-1">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-sk-quote-qty="' + i + '" data-delta="1">+</button>' +
        '</div>' +
        '</li>'
      );
    }).join('');

    Array.prototype.forEach.call(lists, function (list) { list.innerHTML = html; });

    var summary = items.map(function (item) {
      return item.quantity + ' × ' + item.title +
        (item.variantTitle && item.variantTitle !== 'Default Title' ? ' (' + item.variantTitle + ')' : '') +
        (item.sku ? ' [art. ' + item.sku + ']' : '');
    }).join('\n');

    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-quote-field]'), function (field) {
      field.value = summary;
    });
  }

  /* Töm listan efter lyckad inlämning och visa kvittensen */
  if (document.querySelector('[data-sk-quote-success]')) {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      /* ignorera */
    }
  }

  function init() {
    /* Flytta panelen sist i body så den aldrig klipps av sidhuvudet */
    var el = drawer();
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
    updateCount();
    renderList();
    if (document.querySelector('[data-sk-quote-success]')) openDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
